import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SendSmsEdition as SendSmsEditionMutation,
    EditionSendToFilteredListInput,
} from 'nutshell-graphql-types';

import SEND_SMS_EDITION from '../mutations/send-sms-edition.graphql';

export function useSendSmsEdition(): {
    sendEdition: (input: EditionSendToFilteredListInput) => Promise<any>;
    isSending: boolean;
    error: string | null | undefined;
} {
    const [sendEdition, {loading, error}] = useMutation<SendSmsEditionMutation, Record<any, any>>(
        SEND_SMS_EDITION
    );

    return {
        sendEdition: (input: EditionSendToFilteredListInput) =>
            sendEdition({
                variables: {input},
            }),
        isSending: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
